import { render } from "./Painter.vue?vue&type=template&id=1d06abb6"
import script from "./Painter.vue?vue&type=script&lang=js"
export * from "./Painter.vue?vue&type=script&lang=js"

import "./Painter.vue?vue&type=style&index=0&id=1d06abb6&lang=css"
script.render = render

export default script